import { render, staticRenderFns } from "./feed-footer.vue?vue&type=template&id=409667e8&scoped=true&"
import script from "./feed-footer.vue?vue&type=script&lang=js&"
export * from "./feed-footer.vue?vue&type=script&lang=js&"
import style0 from "./feed-footer.vue?vue&type=style&index=0&id=409667e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409667e8",
  null
  
)

export default component.exports